import React, { useContext, useState } from 'react';
import { Button, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

export const ImpersonationBanner = () => {
    const { isImpersonating, loggedUser, stopImpersonation } = useContext(AuthContext);
    const { t } = useTranslation('translation', { keyPrefix: 'common' });
    const [isStopping, setIsStopping] = useState(false);
    const navigate = useNavigate();

    if (!isImpersonating) return null;

    const handleStop = async () => {
        setIsStopping(true);
        const status = await stopImpersonation();
        setIsStopping(false);

        if (status >= 200 && status < 300) {
            navigate('/dashboard', { replace: true });
        }
    };

    return (
        <div
            className='d-flex align-items-center justify-content-center gap-2 w-100 py-1 px-3 border-bottom text-secondary'
            style={{ backgroundColor: '#eef4f7', fontSize: '0.9rem' }}
        >
            <span>{t('impersonationBanner', { name: loggedUser?.name || loggedUser?.username || '' })}</span>
            <Button variant='link' size='sm' className='p-0 text-secondary fw-bold' onClick={handleStop} disabled={isStopping}>
                {isStopping ? <Spinner animation='border' size='sm' /> : t('stopImpersonation')}
            </Button>
        </div>
    );
};
